import type { RouteRecordRaw } from 'vue-router'

/**
 * // alias , 3: 系统 , 4: 目录 5: 模块 , 1: 菜单 , 2: 按钮
 * 从菜单映射到路由的权限
 * @param menuList 菜单的列表
 * @returns 路由的数组
 */

const modules = import.meta.glob('@/views/**/**.vue')
const layout = () => import('@/layout/layout.vue')
export function mapMenusToRoutes(menuList: any[]) {
  if (!menuList) return []
  const routers: RouteRecordRaw[] = []
  function recurve(list: any[], rItem: any, isChild?: boolean) {
    for (const item of list) {
      if (item.type != 3) {
        if (isChild) {
          rItem.children.push(resetRouterItem(item, isChild))
        } else {
          rItem = resetRouterItem(item, isChild)
          routers.push(rItem)
        }
        if (item?.children && item?.children?.length > 0) {
          recurve(item?.children, rItem, true)
        }
      }
    }
  }

  recurve(menuList, {})
  return routers
}

function resetRouterItem(menuItem: any, isChild?: boolean) {
  // const path = menuItem.code.substring(0, 1) == "/" ? menuItem.code.substring(1) : menuItem.code;
  // const newItem: any = {
  //   path,
  //   name: menuItem.code,
  //   meta: { title: menuItem.name },
  //   component: getCpn(getDir(menuItem), modules)
  // };
  // return newItem;

  const newItem: any = {
    path: menuItem.path,
    name: menuItem.name,
    meta: { title: menuItem.title },
    component: menuItem.type == 1 ? layout : getCpn(getDir(menuItem), modules),
    children: []
  }

  if (!isChild && menuItem.type == 2) {
    // newItem.path = menuItem.path
    newItem.path = ''
    // newItem.redirect = `${menuItem.path}`
    newItem.component = layout
    newItem.children = [
      {
        path: menuItem.path,
        component: getCpn(getDir(menuItem), modules),
        meta: { title: menuItem.title }
      }
    ]
  }

  return newItem
}

function getDir(menuItem: any) {
  return `/src/views${menuItem.component}.vue`
}

function getCpn(targetPath: any, modules: any) {
  return modules[targetPath]
}
